import React from 'react';
import { Button, Form } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';
import { isPdfFile } from '../platform/contentAttachments';
import './platform-content-attachments.css';

function ContentAttachmentsEditor({
  label = 'Datoteke',
  accept,
  pdfOnly = false,
  required = false,
  existingAttachments = [],
  onExistingAttachmentsChange,
  newFiles = [],
  onNewFilesChange,
  hint,
}) {
  const handleFileChange = (event) => {
    const selected = Array.from(event.target.files || []);
    event.target.value = '';

    if (!selected.length) {
      return;
    }

    if (pdfOnly) {
      const validFiles = selected.filter(isPdfFile);
      if (!validFiles.length) {
        return;
      }
      onNewFilesChange([...(newFiles || []), ...validFiles]);
      return;
    }

    onNewFilesChange([...(newFiles || []), ...selected]);
  };

  const removeExisting = (index) => {
    onExistingAttachmentsChange(existingAttachments.filter((_, itemIndex) => itemIndex !== index));
  };

  const removeNew = (index) => {
    onNewFilesChange(newFiles.filter((_, itemIndex) => itemIndex !== index));
  };

  const hasAny = existingAttachments.length > 0 || newFiles.length > 0;
  const showPendingBadge = existingAttachments.length > 0;

  return (
    <Form.Group className="platform-content-attachments-editor">
      <Form.Label className="platform-content-attachments-editor__label">
        {label}
        {required && !hasAny ? ' *' : ''}
      </Form.Label>

      {hint && (
        <Form.Text className="platform-content-attachments-editor__hint text-muted">
          {hint}
        </Form.Text>
      )}

      <Form.Control
        type="file"
        multiple
        accept={accept}
        onChange={handleFileChange}
        className="platform-content-attachments-editor__input"
      />

      {hasAny && (
        <ul className="platform-content-attachments-editor__list">
          {existingAttachments.map((attachment, index) => (
            <li key={attachment.url} className="platform-content-attachments-editor__item">
              <a
                href={attachment.url}
                target="_blank"
                rel="noopener noreferrer"
                className="platform-content-attachments-editor__name"
              >
                {attachment.name}
              </a>
              <Button
                type="button"
                variant="outline-danger"
                size="sm"
                aria-label={`Odstrani ${attachment.name}`}
                onClick={() => removeExisting(index)}
              >
                <FaTimes aria-hidden="true" />
              </Button>
            </li>
          ))}

          {newFiles.map((file, index) => (
            <li
              key={`${file.name}-${file.lastModified}-${index}`}
              className="platform-content-attachments-editor__item platform-content-attachments-editor__item--pending"
            >
              <span className="platform-content-attachments-editor__name">{file.name}</span>
              {showPendingBadge && (
                <span className="platform-content-attachments-editor__badge">Nova</span>
              )}
              <Button
                type="button"
                variant="outline-secondary"
                size="sm"
                aria-label={`Odstrani ${file.name}`}
                onClick={() => removeNew(index)}
              >
                <FaTimes aria-hidden="true" />
              </Button>
            </li>
          ))}
        </ul>
      )}
    </Form.Group>
  );
}

export default ContentAttachmentsEditor;
